<template>
  <div v-if="isBannedBrowser" class="text-center p-4">Browser not supported</div>
  <div id="app" v-else>
    <TopNav></TopNav>
    <router-view key="1" v-if="loaded"></router-view>
    <div key="2" class="text-center my-6" v-else>
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <Review></Review>
  </div>
</template>

<script>
import TopNav from './components/TopNav'
import Review from './components/Review'
import _ from 'lodash'

export default {
  components: {
    TopNav,
    Review,
  },
  data() {
    return {
      loaded: false,
    }
  },
  created() {
    if (_.isEmpty(this.course)) {
      this.fetchCourse()
    }
  },
  computed: {
    isBannedBrowser() {
      return /AlohaBrowser/i.test(navigator.userAgent)
    },
    page() {
      return this.$store.state.page
    },
    course() {
      return this.$store.state.course
    },
  },
  methods: {
    checkIfLecturesArePresent(data) {
      // get lectures from data.sections.lectures, sections is an array, use lodash to flatten it
      // if lectures are not present, then redirect  exam (if present)
      const lectures = _.chain(data).get('course.sections', []).map('lectures').flatten().value()

      const exam = _.get(data, 'course.exam_id')

      if (_.isEmpty(lectures) && exam) {
        window.location.href = `/exam/${exam}`
      }
      return true
    },
    fetchCourse() {
      this.$store
        .dispatch('fetchCourse', this.$route.params.course)
        // .then(this.checkIfLecturesArePresent)
        .then(() => {
          this.loaded = true
        })
    },
  },
}
</script>
